/* Shared California clock: one cadence, reference-counted lifecycle subscriptions. */
(function () {
  'use strict';
  var storefront = window.BSStorefront;
  if (storefront.headerClock) return;
  var subscribers = new Set(), timer;
  function subscribe(el, tz, city) {
    tz = tz || 'America/Los_Angeles';
    city = city || 'California';
    var active = true;
    function pad2(n) {
      return String(n).padStart(2, '0');
    }

    function renderTime() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }).formatToParts(new Date());

        var map = {};
        for (var i = 0; i < parts.length; i++) {
          map[parts[i].type] = parts[i].value;
        }

        var mm = map.month || '';
        var dd = map.day || '';
        var yyyy = map.year || '';
        var hour = map.hour || '';
        var minute = map.minute || '';
        var dayPeriod = (map.dayPeriod || '').toLowerCase();

        el.textContent = mm + '/' + dd + '/' + yyyy + ' ' + hour + ':' + minute + dayPeriod + ' ' + city;
      } catch (e) {
        var d = new Date();
        el.textContent =
          pad2(d.getMonth() + 1) + '/' + pad2(d.getDate()) + '/' + d.getFullYear() + ' ' +
          pad2(d.getHours()) + ':' + pad2(d.getMinutes()) + ' ' + city;
      }
    }
    function update() { if (active) renderTime(); }
    update();
    subscribers.add(update);
    if (timer === undefined) timer = setInterval(function () {
      subscribers.forEach(function (render) { render(); });
    }, 30000);
    return function () {
      active = false;
      subscribers.delete(update);
      if (!subscribers.size && timer !== undefined) { clearInterval(timer); timer = undefined; }
    };
  }
  function mount(root) {
    var el = root.querySelector('[data-bs-site-time]') || root.querySelector('.bs-collection-header__time');
    if (el) return subscribe(el, root.getAttribute('data-bs-tz'), root.getAttribute('data-bs-city'));
  }
  storefront.headerClock = {
    subscribe: subscribe,
    unregister: storefront.lifecycle.register('header-clock', '.bs-collection-header', mount),
    unregisterIdentity: storefront.lifecycle.register('site-identity-clock', '.bs-site-identity', mount)
  };
})();
